import React, {useState} from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import {useUser} from "../../../auth/AuthProvider";
import {ApiUrl} from "../../../auth/authMethods";
import LoadingButton from '@mui/lab/LoadingButton';
import {formatDateString} from "../../../utils/formatDateString";

export default function ButtonReport({filter}) {
    const {user} = useUser();
    const [loading, setLoading] = useState(false);

    const handleDownload = async () => {
        try {
            setLoading(true);

            const queryParams = new URLSearchParams(filter).toString();

            const response = await fetch(`${ApiUrl}/pedidos/report/late-orders?${queryParams}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.token}`,
                    'Accept': 'application/octet-stream'
                },
            });

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = getFileName();
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            console.error('Erro ao baixar relatório:', error);
        } finally {
            setLoading(false);
        }
    };

    const getFileName = () => {

        let nomeEvento = "";

        if (filter.nomeEvento)
            nomeEvento = "-" + filter.nomeEvento

        return `lotes-atrasados${nomeEvento}-${formatDateString(new Date(), '-')}.xlsx`
    }


    // Retorna null se o usuário não for admin
    if (!user?.isAdmin) {
        return null;
    }

    return (
        <LoadingButton
            onClick={handleDownload}
            loading={loading}
            loadingPosition="start"
            startIcon={<DownloadIcon/>}
            variant="contained"
            color="primary"
            className="ms-2 float-end"
        >
            Baixar Relatório
        </LoadingButton>
    );
}